<template>
  <div id="keywordSearch">
    <h3>Keyword</h3>
    <div class="fields">
      <input
        type="text"
        title="Refine Topic"
        aria-labelledby="refineTopic"
        name="filterTextInput"
        placeholder="Alki, Rainier Beach, etc."
        v-model="input"
        @keyup.enter="refine()"
      />
      <label class="sr-only" for="refineTopic">
        Refine topics by keywords entered
      </label>
      <button id="refineTopic" @click="refine()">
        <span class="sr-only">Refine</span>
        <i class="far fa-search"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "KeywordSearch",
  props: {
    keywords: Array,
  },
  data() {
    return {
      input: "",
    };
  },

  methods: {
    refine() {
      if (!this.keywords.includes(this.input)) {
        
        //console.log('adding keyword: ', this.input)
        if (this.input != '') {
          this.$emit("add", this.input);
          this.input = '' 
          // this.$router.push({ name: 'Page', params: { page: '1' } })
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
.fields {
  display:flex;
  width:100%;
}

input, 
button {
  height:45px;
}

#keywordSearch input{
  height: 45px !important;
}

input {
  flex-grow: 1;
  border: 1px solid #000;
  border-right: 0;
  padding: 0px 5px;
}
button {
  width: 45px;
  background: #003da5;
  color:#fff;
  border: 0;

  &:hover {
    background: #fff;
    color:#000;
    border:1px solid #000;
  }
}
</style>
